<template>
  <div class="h-screen p-5 flex justify-center dark:text-white text-gray-700">
    <div>
      <h2 class="text-5xl mt-48">Blank Pages</h2>
      <p>Nothing specials here.</p>
    </div>
  </div>
</template>
